import React from "react";
import { GatsbySeo } from "gatsby-plugin-next-seo";
import { Helmet } from "react-helmet";

import Layout from "../components/Layout";
import TrainingCheckout from "../components/TrainingCheckout";
import useSiteMetadata from "../components/SiteMetadata";
import { useTrainings } from "../hooks/useTrainings";

const TrainingCheckoutPage = ({ pageContext }) => {
  const products = useTrainings();
  const { siteUrl } = useSiteMetadata();
  const product = products.find((product) => product.slug === pageContext.slug);
  return (
    <Layout whiteHeader>
      <GatsbySeo
        title={product.seo.title}
        description={product.seo.description}
        openGraph={{
          url: `${siteUrl}${product.slug}/training-buy`,
          title: product.seo.title,
          description: product.seo.description,
          images: [{ url: `${siteUrl}${product.seo.image.publicURL}` }],
          site_name: "MycoForest",
        }}
      />
      <Helmet>
        <script src="https://checkout.razorpay.com/v1/checkout.js" async />
      </Helmet>
      <TrainingCheckout product={product} />
    </Layout>
  );
};

export default TrainingCheckoutPage;
